import * as React from 'react';

import { selectNewbuildingBrokerSelfRequestFormWidgetActive } from '../../selectors/newbuildings/newbuildingBrokerSelfRequestFormWidget';
import { useAppSelector as useSelector } from '../../types';
import { NewbuildingBrokerSelfRequestFormWidgetAdapterLazy } from './NewbuildingBrokerSelfRequestFormWidgetAdapterLazy';

export const NewbuildingBrokerSelfRequestFormWidgetContainer: React.FC = () => {
  const active = useSelector(selectNewbuildingBrokerSelfRequestFormWidgetActive);

  if (!active) {
    return null;
  }

  return (
    // Фоллбэк не нужен, так как во время загрузки отображается спиннер на кнопке.
    <React.Suspense fallback={null}>
      <NewbuildingBrokerSelfRequestFormWidgetAdapterLazy />
    </React.Suspense>
  );
};
